import { Link } from 'react-router-dom'
import { ChevronRight, GitMerge } from 'lucide-react'
import { Card, CardContent } from '../../components/ui/card'
import { BranchesCard } from './components/BranchesCard'
import { CreateBranchCard } from './components/CreateBranchCard'

/**
 * Settings → Branches: a card linking out to the durable "merges in progress"
 * list, the create-branch card, then the full paginated branch browser.
 */
export function BranchesTab() {
  return (
    <div className="flex flex-col gap-card">
      <Link to="/branches/merges" className="group block" aria-label="Merges in progress">
        <Card className="gap-0 py-3 transition-colors group-hover:border-brand/60">
          <CardContent className="flex items-center gap-3">
            <GitMerge className="size-5 shrink-0 text-brand" />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-ink">Merges in progress</div>
              <div className="text-xs text-ink-3">
                Open merge reviews across branches — resume or abandon them.
              </div>
            </div>
            <ChevronRight className="size-4 shrink-0 text-ink-3 transition-colors group-hover:text-brand" />
          </CardContent>
        </Card>
      </Link>
      <CreateBranchCard />
      <BranchesCard />
    </div>
  )
}
